
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[totalAlias]/drafts",
      function () {
        return require("private-next-pages/search/[totalAlias]/drafts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[totalAlias]/drafts"])
      });
    }
  